import React from 'react'

export interface PageTitleProps {
	title: string
	subtitle?: string
}

export const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle }) => (
	<div className="mb-6 max-w-4xl pt-2 pb-2">
		<h1 className="text-foreground text-2xl font-bold tracking-tight lg:text-3xl">
			{title}
		</h1>
		{subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
	</div>
)

export default PageTitle
